import { Link } from 'react-router-dom'
import { SITE } from '../config/site'
import styles from './Footer.module.css'

const LINKS: { label: string; href?: string; to?: string }[] = [
  { label: 'How it works', href: '/#how-it-works' },
  { label: 'Gestures', href: '/#gestures' },
  { label: 'FAQ', href: '/#faq' },
  { label: 'Pricing', href: '/#pricing' },
  { label: 'Buy Gesturely', to: '/buy' },
  { label: 'Support', href: `mailto:${SITE.supportEmail}` },
  { label: 'Privacy', to: '/privacy' },
  { label: 'Terms', to: '/terms' },
  { label: 'Refund Policy', to: '/refunds' },
]

export function Footer() {
  const year = new Date().getFullYear()

  return (
    <footer className={styles.footer} role="contentinfo">
      <div className={`container container--wide ${styles.inner}`}>
        <div className={styles.brand}>
          <Link to="/" className={styles.wordmark}>
            {SITE.productName}
          </Link>
          <p className={styles.tagline}>{SITE.tagline}</p>
        </div>

        <nav className={styles.nav} aria-label="Footer">
          {LINKS.map((item) =>
            item.to ? (
              <Link key={item.label} to={item.to} className={styles.link}>
                {item.label}
              </Link>
            ) : (
              <a key={item.label} href={item.href} className={styles.link}>
                {item.label}
              </a>
            )
          )}
        </nav>
      </div>

      <div className={`container container--wide ${styles.bottom}`}>
        <p className={styles.copy}>
          © {year} {SITE.legalName}. All rights reserved.
        </p>
        <p className={styles.copy}>
          Payments processed by{' '}
          <a href="https://paddle.com" target="_blank" rel="noopener noreferrer">
            Paddle, our Merchant of Record
          </a>
        </p>
      </div>
    </footer>
  )
}
